export const SET_LOGIN_STATE = 'SET_LOGIN_STATE'

export const SET_TICKET = 'SET_TICKET'

export const SET_CIRD_TICKET = 'SET_CIRD_TICKET'

export const SET_PRIVILEGE_DICTIONARY = 'SET_PRIVILEGE_DICTIONARY'

export const SET_QUERY_PRIVILEGE = 'SET_QUERY_PRIVILEGE'

export const SET_USERINFO = 'SET_USERINFO'
export const DEL_USERINFO = 'DEL_USERINFO'

export const SET_HISTORY_USERINFO = 'SET_HISTORY_USERINFO'
export const DEL_HISTORY_USERINFO = 'DEL_HISTORY_USERINFO'

// data-manage
export const DATA_MANAGE_PUSH_TARGET = 'DATA_MANAGE_PUSH_TARGET'
export const DATA_MANAGE_DOMAIN_DATA = 'DATA_MANAGE_DOMAIN_DATA'
export const DATA_MANAGE_HISTORY_DATA = 'DATA_MANAGE_HISTORY_DATA'
export const DATA_MANAGE_PROPERTY_DATA = 'DATA_MANAGE_PROPERTY_DATA'

// topic-manage
export const SET_HISTORY_TOPIC = 'SET_HISTORY_TOPIC'

// role-manage
export const SET_ALL_ROLES = 'SET_ALL_ROLES'

// register的显示和隐藏
export const REGISTER_SHOW = 'REGISTER_SHOW'
export const REGISTER_CLOSE = 'REGISTER_CLOSE'

// login的显示和隐藏
export const LOGIN_SHOW = 'LOGIN_SHOW'
export const LOGIN_CLOSE = 'LOGIN_CLOSE'
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js